import React from 'react'
const SettingContextStep3 = React.createContext({})
export const SettingProviderStep3 = SettingContextStep3.Provider
export default SettingContextStep3